export function startVersionCheck({
  url = "/version.json",
  intervalMs = 30_000,           // check every 30s
  storageKey = "__app_version__", // localStorage key
  queryParam = "v",               // adds ?v=<version> on refresh
} = {}) {
  const safeGet = (k) => {
    try { return localStorage.getItem(k); } catch { return null; }
  };

  const safeSet = (k, v) => {
    try { localStorage.setItem(k, v); } catch { /* ignore */ }
  };

  async function clearSWAndCaches() {
    // Clears only SW + CacheStorage for this origin (does NOT clear cookies/indexeddb/etc.)
    try {
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch { /* ignore */ }

    try {
      if (window.caches?.keys) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch { /* ignore */ }
  }

  function forceFreshNavigation(version) {
    // Change URL => bypass "cached document at exact URL"
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set(queryParam, version);
    // Replace avoids polluting back-button history
    window.location.replace(nextUrl.toString());
  }

  async function check() {
    try {
      // Cache-bust version.json fetch (helps even if CDN caches aggressively)
      const bustUrl = `${url}?t=${Date.now()}`;
      const res = await fetch(bustUrl, {
        cache: "no-store",
        headers: { "cache-control": "no-cache" },
      });
      if (!res.ok) return;

      const data = await res.json();
      const next = data?.version;
      if (!next) return;

      const prev = safeGet(storageKey);

      // First run: store and exit (no refresh)
      if (!prev) {
        safeSet(storageKey, next);
        return;
      }

      // Same version: nothing to do
      if (next === prev) return;

      // Version changed => store it, clear SW/caches, and force fresh navigation
      safeSet(storageKey, next);
      await clearSWAndCaches();
      forceFreshNavigation(next);
    } catch {
      // ignore network/JSON errors
    }
  }

  // run now + on interval
  check();
  const timer = setInterval(check, intervalMs);

  // optional cleanup function
  return () => clearInterval(timer);
}
